// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-buyer-container > div.contents {
  padding: 0 140px;
  display: flex;
  width: 100%;
}
.select-buyer-container > div.contents .more-options-container .selectbox, .select-buyer-container > div.contents .agent-slider .selectbox {
  background-color: white !important;
  margin: 3px;
  height: 400px;
  box-shadow: 0px 0.5px 4px rgba(0, 0, 0, 0.3019607843);
  border-radius: 15px !important;
  border: 2px solid white;
  transition: 0.2s ease-in-out;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 30px;
  text-align: center;
  cursor: pointer;
  transition: 0.3s ease-in-out;
}
.select-buyer-container > div.contents .more-options-container .selectbox::after, .select-buyer-container > div.contents .agent-slider .selectbox::after {
  content: "";
  width: 25px;
  height: 25px;
  background-color: var(--secondary-color-2);
  position: absolute;
  right: 15px;
  top: 15px;
  border-radius: 5px;
  transition: 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
}
.select-buyer-container > div.contents .more-options-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1 1;
}
.select-buyer-container > div.contents .more-options-container .selectbox {
  width: 400px;
}
.select-buyer-container > div.contents .more-options-container .selectbox .header {
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
  font-size: 30px;
  color: var(--secondary-color-1);
}
.select-buyer-container > div.contents .more-options-container .selectbox .subheader {
  font-family: "Roboto", sans-serif;
  font-weight: 16px;
  color: var(--secondary-color-1);
  line-height: 25px;
}
.select-buyer-container > div.contents .more-options-container .selectbox:hover {
  border-color: var(--primary-color-1) !important;
}
.select-buyer-container > div.contents .more-options-container .selectbox:hover::after {
  background-color: transparent;
  width: 15px;
  height: 27px;
  border: solid var(--primary-color-1);
  border-width: 0 6px 6px 0;
  transform: rotate(45deg);
  position: absolute;
  border-radius: 0;
  top: 10px;
  right: 20px;
}
.select-buyer-container > div.contents .more-options-container .selectbox.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.select-buyer-container > div.contents .more-options-container .selectbox.disabled:hover::after {
  content: "";
  width: 25px;
  height: 25px;
  background-color: var(--secondary-color-2);
  position: absolute;
  right: 15px;
  top: 15px;
  border-radius: 5px;
  transition: 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
  transform: rotate(0);
  border: none;
}
.select-buyer-container > div.contents .agent-slider {
  padding: 0 105px;
  display: flex;
  width: 60vw;
  flex: 1 1;
}
.select-buyer-container > div.contents .agent-slider .selectbox {
  overflow: hidden;
  border: none;
  flex: 1 1;
  width: 291px;
}
.select-buyer-container > div.contents .agent-slider .selectbox:hover {
  border-color: var(--primary-color-1) !important;
}
.select-buyer-container > div.contents .agent-slider .selectbox:hover::after {
  background-color: transparent;
  width: 15px;
  height: 27px;
  border: solid white;
  border-width: 0 6px 6px 0;
  transform: rotate(45deg);
  position: absolute;
  border-radius: 0;
  top: 10px;
  right: 20px;
}
.select-buyer-container > div.contents .agent-slider .selectbox .agent-company {
  height: 180px;
  width: 100%;
  position: absolute;
  top: 0;
  margin: -2px;
  background-color: var(--primary-color-1);
  padding-top: 50px;
}
.select-buyer-container > div.contents .agent-slider .selectbox .agent-company > img {
  padding: 0 25px;
}
.select-buyer-container > div.contents .agent-slider .selectbox::after {
  content: "";
  width: 25px;
  height: 25px;
  background-color: var(--secondary-color-4);
  position: absolute;
  right: 15px;
  top: 15px;
  border-radius: 5px;
}
.select-buyer-container > div.contents .agent-slider .selectbox .agent-profile--image {
  z-index: 2;
  margin-top: 80px;
}
.select-buyer-container > div.contents .agent-slider .selectbox .agent-profile--image .agent-profile--avatar {
  border: 5px solid white;
  position: relative;
}
.select-buyer-container > div.contents .agent-slider .selectbox .agent-profile--image .agent-profile--avatar > svg {
  position: absolute;
  bottom: -12px;
}
.select-buyer-container > div.contents .agent-slider .splide__arrow {
  background: none;
  border-radius: 0;
  width: 35px;
  height: 25px;
  border-radius: 0;
}
.select-buyer-container > div.contents .agent-slider .splide__arrow--prev,
.select-buyer-container > div.contents .agent-slider .splide__arrow--next {
  opacity: 1 !important;
  transition: 0.2s ease-in-out;
}
.select-buyer-container > div.contents .agent-slider .splide__arrow--prev:hover,
.select-buyer-container > div.contents .agent-slider .splide__arrow--next:hover {
  opacity: 0.7 !important;
}
.select-buyer-container > div.contents .agent-slider .splide__arrow svg {
  height: auto;
  width: auto;
}
.select-buyer-container > div.contents .agent-slider .splide__arrow--prev svg {
  transform: none;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .select-buyer-container > div.contents {
    padding: 0 20px;
    flex-direction: column;
    width: 100%;
  }
  .select-buyer-container > div.contents .more-options-container {
    position: relative;
    margin-top: 60px;
    justify-content: center;
  }
  .select-buyer-container > div.contents .more-options-container::before {
    content: "OR";
    font-size: 16px;
    font-weight: 700;
    position: absolute;
    top: 0;
    margin-top: -40px;
    color: var(--secondary-color-2);
  }
  .select-buyer-container > div.contents .agent-slider {
    padding: 0;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/ShowingRequest/modules/SelectBuyer/selectBuyer.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAGI;EACI,gBAAA;EACA,aAAA;EACA,WAAA;AAFR;AAGQ;EACI,kCAAA;EACA,WAAA;EACA,aAAA;EACA,qDAAA;EACA,8BAAA;EACA,uBAAA;EACA,4BAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;AADZ;AAEY;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,oDAAA;AAAhB;AAGQ;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AADZ;AAEY;EACI,YAAA;AAAhB;AACgB;EACI,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AACpB;AACgB;EACI,iCAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;AACpB;AACgB;EACI,+CAAA;AACpB;AAAoB;EACI,6BAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,yBAAA;EAGA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;AAExB;AACgB;EACI,mBAAA;EACA,YAAA;AACpB;AAAoB;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,oDAAA;EAGA,oBAAA;EACA,YAAA;AAExB;AAGQ;EACI,gBAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;AADZ;AAEY;EACI,gBAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;AAAhB;AACgB;EACI,+CAAA;AACpB;AAAoB;EACI,6BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EAGA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;AAExB;AACgB;EACI,aAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,wCAAA;EACA,iBAAA;AACpB;AAAoB;EACI,eAAA;AAExB;AACgB;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;AACpB;AAEgB;EACI,UAAA;EACA,gBAAA;AAApB;AACoB;EACI,uBAAA;EACA,kBAAA;AACxB;AAAwB;EACI,kBAAA;EACA,aAAA;AAE5B;AAGY;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AADhB;AAGY;;EAEI,qBAAA;EACA,4BAAA;AADhB;AAEgB;;EAAU,uBAAA;AAE1B;AAAY;EACI,YAAA;EACA,WAAA;AAEhB;AAAY;EACI,eAAA;AAEhB;;AC7KY;EDmLJ;IACI,eAAA;IACA,sBAAA;IACA,WAAA;EAFV;EAGU;IACI,kBAAA;IACA,gBAAA;IACA,uBAAA;EADd;EAEc;IACI,aAAA;IACA,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,MAAA;IACA,iBAAA;IACA,+BAAA;EAAlB;EAGU;IACI,UAAA;IACA,WAAA;EADd;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.select-buyer-container {\n    > div.contents {\n        padding: 0 140px;\n        display: flex;\n        width: 100%;\n        .more-options-container .selectbox, .agent-slider .selectbox {\n            background-color: white !important;\n            margin: 3px;\n            height: 400px;\n            box-shadow: 0px 0.5px 4px #0000004D;\n            border-radius: 15px !important;\n            border: 2px solid white;\n            transition: .2s ease-in-out;\n            align-items: center;\n            justify-content: center;\n            display: flex;\n            flex-direction: column;\n            position: relative;\n            padding: 30px;\n            text-align: center;\n            cursor: pointer;\n            transition: .3s ease-in-out;\n            &::after {\n                content: \"\";\n                width: 25px;\n                height: 25px;\n                background-color: var(--secondary-color-2);\n                position: absolute;\n                right: 15px;\n                top: 15px;\n                border-radius: 5px;\n                transition: .2s cubic-bezier(0.075, 0.82, 0.165, 1);\n            }\n        }\n        .more-options-container {\n            display: flex;\n            justify-content: flex-end;\n            align-items: center;\n            flex: 1;\n            .selectbox {\n                width: 400px;\n                .header {\n                    font-family: 'Proxima Nova', sans-serif;\n                    font-weight: 700;\n                    font-size: 30px;\n                    color: var(--secondary-color-1);\n                }\n                .subheader {\n                    font-family: \"Roboto\", sans-serif;\n                    font-weight: 16px;\n                    color: var(--secondary-color-1);\n                    line-height: 25px;\n                }\n                &:hover { \n                    border-color: var(--primary-color-1)!important;\n                    &::after {\n                        background-color: transparent;\n                        width: 15px;\n                        height: 27px;\n                        border: solid var(--primary-color-1);\n                        border-width: 0 6px 6px 0;\n                        -webkit-transform: rotate(45deg);\n                        -ms-transform: rotate(45deg);\n                        transform: rotate(45deg);\n                        position: absolute;\n                        border-radius: 0;\n                        top: 10px;\n                        right: 20px;\n                    }\n                }\n                &.disabled {\n                    cursor: not-allowed;\n                    opacity: .5;\n                    &:hover::after {\n                        content: \"\";\n                        width: 25px;\n                        height: 25px;\n                        background-color: var(--secondary-color-2);\n                        position: absolute;\n                        right: 15px;\n                        top: 15px;\n                        border-radius: 5px;\n                        transition: .2s cubic-bezier(0.075, 0.82, 0.165, 1);\n                        -webkit-transform: rotate(0);\n                        -ms-transform: rotate(0);\n                        transform: rotate(0);\n                        border: none;\n                    }\n                }\n            }\n        }\n        .agent-slider {\n            padding: 0 105px;\n            display: flex;\n            width: 60vw;\n            flex: 1;\n            .selectbox {\n                overflow: hidden;\n                border: none;\n                flex: 1;\n                width: 291px;\n                &:hover { \n                    border-color: var(--primary-color-1)!important;\n                    &::after {\n                        background-color: transparent;\n                        width: 15px;\n                        height: 27px;\n                        border: solid white;\n                        border-width: 0 6px 6px 0;\n                        -webkit-transform: rotate(45deg);\n                        -ms-transform: rotate(45deg);\n                        transform: rotate(45deg);\n                        position: absolute;\n                        border-radius: 0;\n                        top: 10px;\n                        right: 20px;\n                    }\n                }\n                .agent-company {\n                    height: 180px;\n                    width: 100%;\n                    position: absolute;\n                    top: 0;\n                    margin: -2px;\n                    background-color: var(--primary-color-1);\n                    padding-top: 50px;\n                    > img {\n                        padding: 0 25px;\n                    }\n                }\n                &::after {\n                    content: \"\";\n                    width: 25px;\n                    height: 25px;\n                    background-color: var(--secondary-color-4);\n                    position: absolute;\n                    right: 15px;\n                    top: 15px;\n                    border-radius: 5px;\n                  \n                }\n                .agent-profile--image {\n                    z-index: 2;\n                    margin-top: 80px;\n                    .agent-profile--avatar {\n                        border: 5px solid white;\n                        position: relative;\n                        > svg {\n                            position: absolute;\n                            bottom: -12px;\n                        }\n                    }\n                }\n            }\n            .splide__arrow {\n                background: none;\n                border-radius: 0;\n                width: 35px;\n                height: 25px;\n                border-radius: 0;\n            }\n            .splide__arrow--prev,\n            .splide__arrow--next {\n                opacity: 1 !important;\n                transition: .2s ease-in-out;\n                &:hover { opacity: .7 !important; }\n            }\n            .splide__arrow svg {\n                height: auto;\n                width: auto;\n            }\n            .splide__arrow--prev svg {\n                transform: none;\n            }\n        }\n    }\n}\n\n@include media(mobile) {\n    .select-buyer-container {\n        > div.contents {\n            padding: 0 20px;\n            flex-direction: column;\n            width: 100%;\n            .more-options-container {\n                position: relative;\n                margin-top: 60px;\n                justify-content: center;\n                &::before {\n                    content: 'OR';\n                    font-size: 16px;\n                    font-weight: 700;\n                    position: absolute;\n                    top: 0;\n                    margin-top: -40px;\n                    color: var(--secondary-color-2);\n                }\n            }\n            .agent-slider {\n                padding: 0;\n                width: 100%;\n            }\n        }\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
